import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OccupancyData } from '../../../modules/resourceOrder/occupancyTypes';

/** key is ageCategoryId */
export type ConfigurationOccupancy = Record<string, OccupancyData>;

/** key is enterpriseId */
export type DateOccupancy = Record<string, ConfigurationOccupancy>;

export const OCCUPANCY_SLICE_NAME = 'dateOccupancy';

const dataInitialState: DateOccupancy = {};

const occupancySlice = createSlice({
    name: OCCUPANCY_SLICE_NAME,
    initialState: dataInitialState,
    reducers: {
        dateOccupancySet: (_state, { payload }: PayloadAction<DateOccupancy>) => payload,
        enterpriseDateOccupancySet: (
            state,
            {
                payload: { ageCategoryId, enterpriseId, personCount },
            }: PayloadAction<OccupancyData & { enterpriseId: string }>
        ) => {
            if (state[enterpriseId] == null) {
                state[enterpriseId] = {};
            }

            state[enterpriseId][ageCategoryId] = { ageCategoryId, personCount };
        },
        enterpriseDateOccupanciesSet: (
            state,
            {
                payload: { enterpriseId, occupancy },
            }: PayloadAction<{ enterpriseId: string; occupancy: ConfigurationOccupancy }>
        ) => {
            state[enterpriseId] = occupancy;
        },
    },
});

export const { dateOccupancySet, enterpriseDateOccupancySet, enterpriseDateOccupanciesSet } = occupancySlice.actions;

export const { reducer: occupancyReducer } = occupancySlice;
